<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="application_status_list" dense class="elevation-1 mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Addmission Application Status</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="2" cols="12"> </v-col>
            <v-col sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>
                  Add Admission Application Status
                </v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="application_status_super_master"
                            v-model="addedItem.application_status_super_master" label="Select Application Status"
                            :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.applicationStatus" persistent-hint
                            :disabled="editedIndex != -1" :rules="[(v) => !!v || 'required']" :hint="
                              editedIndex == -1
                                ? 'For example :: Confirmed, Completed, Pending '
                                : 'noneditable'
                            " label="Blood Group"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" >Application Status
                          <v-select dense
                            v-model="editedItem.applicationStatus"
                            persistent-hint
                            :hint="editedIndex==-1?'For example :: Confirmed, Completed, Pending ':'noneditable'"
                            :error="errorMsg.applicationStatus?true:false"
                            :error-messages="errorMsg.applicationStatus?'Required':''"
                          ></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.is_display_status" color="success" label="Is Display Status"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
        <template v-slot:item.is_display_status="{ item }">
          <span v-if="item.is_display_status">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>-->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>-->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      applicationStatus: false,
    },
    // extraBreadcrumbItems: [
    //   { text: "Application Status Master", disabled: true, href: "" },
    // ],
    // breadcrumbClass: "breadcrumb-style2",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    application_status_super_master: null,
    headers: [
      {
        text: "ApplicationStatus",
        align: "left",
        sortable: false,
        value: "applicationStatus",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      {
        text: "Is Display Status",
        align: "left",
        sortable: true,
        value: "is_display_status",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    application_status_list: [],
    editedIndex: -1,
    addedItem: {
      application_status_super_master: "",
    },
    editedItem: {
      id: "",
      applicationStatus: "",
      isactive: true,
      is_display_status : true
    },
    defaultItem: {
      id: "",
      applicationStatus: "",
      isactive: true,
      is_display_status: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Application Status"
        : "Edit Application Status";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },

  methods: {
    //   initialize () {
    initializeErrorMsgFalse() {
      this.errorMsg.applicationStatus = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/applicationStatus")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.application_status_super_master =
                res.data.application_status_super_master;
              this.application_status_list = res.data.application_status_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.application_status_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editApplicationStatus", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.application_status_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Application Status Updated Successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/AdmissionMaster/saveApplicationStatus", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.application_status_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Application Status Added Successfully!!!"
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Application Status Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
      if (this.editedItem.applicationStatus) {
        return true;
      } else {
        if (!this.editedItem.applicationStatus) {
          this.errorMsg.applicationStatus = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
